var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(this[_vm.$t(("org.infomation." + _vm.NAMESPACE))])}})])}
var staticRenderFns = []

export { render, staticRenderFns }